import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import SendWithdrawRequestWidget from '../../../widgets/progressReportWidget/withdraw/SendWithdrawRequestWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  getWidthdrawRequestApprove,
  getWithdrawRequestStatus,
  getWithdrawRequestBudget,
} from '../../../redux/actions/withdrawRequest'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import WithdrawRequestStatusWidget from '../../../widgets/progressReportWidget/withdraw/WithdrawRequestStatusWidget'
import Budget from '../../../widgets/budget/Budget'

export default function SendWithdrawRequest() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [withdrawRequestStatusSchema, setWithdrawRequestStatusSchema] = useState()
  const [isWithdrawNotMatch, setIsWithdrawNotMatch] = useState(false)
  const [disableSendBack, setDisableSendBack] = useState(false)
  const [nowRequestData, setNowRequestData] = useState()
  const [isWithdrawOver, setIsWithdrawOver] = useState(false)
  const [paymentSchema, setPaymentSchema] = useState()
  const [isSaveWithdrawPlan, setIsSaveWithdrawPlan] = useState()
  const [requestId, setRequestId] = useState()

  useEffect(() => {
    // let requestId = location.search.substring(1)
    // let requestId = sessionStorage.getItem('param')?.substring(1)
    // console.log('load SendWithdrawRequest request_id: ', projectId, 'request_id: ', requestId)
    if (projectId) {
      handleGetSchema(projectId)
      handleGetWithdrawRequestStatusSchema(projectId)
    }
  }, [location.search])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getWidthdrawRequestApprove(projectVersionId)

      setSchema(response)

      setRequestId(response?.forms?.requestNote?.requestId)

      const payResponse = await getWithdrawRequestBudget(
        projectId,
        response?.forms?.requestNote?.requestId
      )
      console.log('PaymentSchema', payResponse)
      setPaymentSchema(payResponse)
      setIsSaveWithdrawPlan(payResponse?.forms?.plannedDisbursement?.isDisabled)

      //handleGetPaymentSchema()
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetWithdrawRequestStatusSchema = async (projectVersionId) => {
    //setIsLoading(true)
    //startLoading()
    try {
      const _withdrawRequestStatus = await getWithdrawRequestStatus(projectVersionId)
      setWithdrawRequestStatusSchema(_withdrawRequestStatus)

      //หางวดที่ขอมา แล้วเปรียบเทียบว่าจำนวนงวดเงิน และงวดที่ขอ เท่ากันไหม กรณีไม่เท่า set ข้อความบอก
      const nowRequest = _withdrawRequestStatus?.forms?.withdrawRequestStatus?.values?.find(
        (item) => item.statusCode === 1
      )

      //ตรวจสอบยอดเกิน กรณีที่เกิน จะมีแจ้งเตือนและ disable ปุ่มส่งเสนออนุมัติ
      if (nowRequest?.installmentAmt < nowRequest?.requestAmt) {
        console.log('installmentAmt', nowRequest?.installmentAmt)
        console.log('requestAmt', nowRequest?.requestAmt)

        setIsWithdrawOver(nowRequest?.requestAmt - nowRequest?.installmentAmt)
      } else {
        setIsWithdrawOver(false)
      }

      //ตรวจสอบกรณีเบิกไม่เต็มงวด แจ้งเตือนเงินงวดประมาณที่ขอเบิกไม่เท่ากับที่ขออนุมัติ แต่สามารถทำต่อได้
      if (nowRequest?.installmentAmt !== nowRequest?.requestAmt) {
        setIsWithdrawNotMatch(true)
      } else {
        setIsWithdrawNotMatch(false)
      }

      setNowRequestData(nowRequest) //ใช้ตรวจสอบว่า ตอนนี้ของวดไหนอยู่

      //หางวดที่ 1 ถ้าเป็นการของวดที่ 1 ให้ซ่อนปุ่มส่งกลับภาคี
      const firstInstallment = _withdrawRequestStatus?.forms?.withdrawRequestStatus?.values?.find(
        (item) => item.installmentNo === 1
      )
      if (firstInstallment.statusCode === 1) {
        setDisableSendBack(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    //doneLoading()
    //setIsLoading(false)
  }

  const handleOnComplete = (isDisabled) => {
    handleGetWithdrawRequestStatusSchema(projectId)
    setIsSaveWithdrawPlan(isDisabled)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schema.forms.agreementDetails} />
        )}

        {withdrawRequestStatusSchema.forms.withdrawRequestStatus && (
          <WithdrawRequestStatusWidget
            showCommandButton={true}
            schema={withdrawRequestStatusSchema.forms.withdrawRequestStatus}
          />
        )}

        <br />

        {paymentSchema && (
          <Budget
            schema={paymentSchema?.forms}
            isEditable={!paymentSchema?.disabled}
            defaultExpandAllRows={true}
            isShowBudgetSubmitButton={false}
            isCollapseAllTableRow={false}
            isHideBudgetPlan={true}
            isHidePeriodExpenses
            isHideBudgetInstallmentPlan
            //onClickConfirmBudget={handleConfirmBudget}
            //withdrawRequestStatusSchema={withdrawRequestStatusSchema}
            isWithdraw={true}
            requestId={requestId}
            onComplete={(isDisabled) => handleOnComplete(isDisabled)}
            schemaButton={schema.forms}
            onSuccess={() => handleGetSchema(projectId)}
          />
        )}

        <br />

        {schema?.forms?.requestNote?.note && (
          <SendWithdrawRequestWidget
            showCommandButton={true}
            schema={schema.forms.requestNote}
            isWithdrawNotMatch={isWithdrawNotMatch}
            disableSendBack={disableSendBack}
            disabledSendWithdraw={schema.disabled}
            nowRequestNo={nowRequestData?.installmentNo}
            isWithdrawOver={isWithdrawOver}
            isSaveWithdrawPlan={isSaveWithdrawPlan}
            bankInformation={paymentSchema.forms.plannedDisbursement.inputForm.bankInformation}
            requestId={requestId}
          />
        )}
        <br />
      </SidebarProposal>
    </>
  )
}
